import { Injectable } from '@angular/core';
import { LightProject } from '@custom-types/project';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalDataService {

  public steps: any;
  public stepsCategory: any;

  public token: string;
  public user: any;
  private projects: any[];
  private currentProjectId: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  private currentProject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public financial:any = null;

  public units: any;

  constructor() {
  }

  getUser() {
    return this.user;
  }

  public setCurrentProjectId(projectId: string) {
    this.currentProjectId.next(projectId);
  }

  public getCurrentProjectId(): Observable<string> {
    return this.currentProjectId;
  }

  public setCurrentProject(project: any) {
    this.currentProject.next(project);
  }

  public getCurrentProject(): Observable<any> {
    return this.currentProject;
  }

  public getProjects(): any[] {
    return this.projects;
  }

  public setProjects(projects: LightProject[]) {
    this.projects = projects;
  }

  public getUnitLabel(id: number): string {
    if (this.units) {
      const found = this.units.find(i => i.id === id);
      if (found) {
        return found.type;
      }
    }
  }

  public checkStepIsBefore(currentStep:string, stepToCompare:string): boolean {
    const indexCurrentStep = this.steps.findIndex(step => step.slug === currentStep);
    const indexTopCompare = this.steps.findIndex(step => step.slug === stepToCompare);
    return indexCurrentStep < indexTopCompare;
  }
}
